var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "marker-pin-04",
    clipPath: "url(#clip0_4410_13364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M4.16675 11.9056C2.62395 12.5862 1.66675 13.5346 1.66675 14.5837C1.66675 16.6547 5.39771 18.3337 10.0001 18.3337C14.6025 18.3337 18.3334 16.6547 18.3334 14.5837C18.3334 13.5346 17.3762 12.5862 15.8334 11.9056M15.0001 6.66699C15.0001 10.0534 11.2501 11.667 10.0001 14.167C8.75008 11.667 5.00008 10.0534 5.00008 6.66699C5.00008 3.90557 7.23866 1.66699 10.0001 1.66699C12.7615 1.66699 15.0001 3.90557 15.0001 6.66699ZM10.8334 6.66699C10.8334 7.12723 10.4603 7.50033 10.0001 7.50033C9.53984 7.50033 9.16675 7.12723 9.16675 6.66699C9.16675 6.20676 9.53984 5.83366 10.0001 5.83366C10.4603 5.83366 10.8334 6.20676 10.8334 6.66699Z",
    stroke: "black",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4410_13364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.7dd352a9179accbd78fb9731b04b3f84.svg";
export { ForwardRef as ReactComponent };